import { render, staticRenderFns } from "./audio_test.vue?vue&type=template&id=52b4d596&scoped=true"
import script from "./audio_test.vue?vue&type=script&lang=js"
export * from "./audio_test.vue?vue&type=script&lang=js"
import style0 from "./audio_test.vue?vue&type=style&index=0&id=52b4d596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b4d596",
  null
  
)

export default component.exports